import { useEffect, useState, type SyntheticEvent } from 'react';

type PhotoThumbProps = {
  src: string;
  alt: string;
  className?: string;
  imgClassName?: string;
};

export function PhotoThumb({ src, alt, className = '', imgClassName = '' }: PhotoThumbProps) {
  const [fit, setFit] = useState<'cover' | 'contain'>('cover');

  useEffect(() => {
    setFit('cover');
  }, [src]);

  const handleLoad = (event: SyntheticEvent<HTMLImageElement>) => {
    const img = event.currentTarget;
    if (img.naturalHeight > img.naturalWidth) {
      setFit('contain');
    }
  };

  return (
    <div className={`bg-muted overflow-hidden flex items-center justify-center ${className}`.trim()}>
      <img
        src={src}
        alt={alt}
        onLoad={handleLoad}
        className={`h-full w-full ${fit === 'cover' ? 'object-cover' : 'object-contain'} ${imgClassName}`.trim()}
      />
    </div>
  );
}
